import {Component, inject, OnInit} from "@angular/core";
import {Observable} from "rxjs";
import {Newsletter, StaticContentService} from "@kwsoft/otcx-core";

@Component({
    selector: "otcx-home-newsletter",
    templateUrl: "./home-newsletter.component.html",
    standalone: false
})
export class HomeNewsletterComponent implements OnInit {
    newsletter$: Observable<Newsletter>;

    private readonly staticContentService = inject(StaticContentService);

    ngOnInit(): void {
        this.newsletter$ = this.staticContentService.getNewsletter();
    }

}
